<template>
  <div class="quarters-area">
    <ul :key="`quartersArea${key}`" class="quarters-list">
      <li class="quarters-list-item">
        <header>Quarter 1</header>
        <SelectDayMonthRange
          ref="quarter1"
          :start.sync="quarter1.start"
          :end.sync="quarter1.end"
          :before="quarter2.start"
          :current-year="currentYear"
          :next-year="nextYear"
          @on-change="
            ({ type, value }) => onChange({ type, value, quarter: 1 })
          "
        />
      </li>
      <li class="quarters-list-item">
        <header>Quarter 2</header>
        <SelectDayMonthRange
          :start.sync="quarter2.start"
          :end.sync="quarter2.end"
          :after="quarter1.end"
          :before="quarter3.start"
          :current-year="currentYear"
          :next-year="nextYear"
          @on-change="
            ({ type, value }) => onChange({ type, value, quarter: 2 })
          "
        />
      </li>
      <li class="quarters-list-item">
        <header>Quarter 3</header>
        <SelectDayMonthRange
          :start.sync="quarter3.start"
          :end.sync="quarter3.end"
          :after="quarter2.end"
          :before="quarter4.start"
          :current-year="currentYear"
          :next-year="nextYear"
          @on-change="
            ({ type, value }) => onChange({ type, value, quarter: 3 })
          "
        />
      </li>
      <li class="quarters-list-item">
        <header>Quarter 4</header>
        <SelectDayMonthRange
          :start.sync="quarter4.start"
          :end.sync="quarter4.end"
          :after="quarter3.end"
          :start-next-year="quarter4.startNextYear"
          :end-next-year="quarter4.endNextYear"
          :disable-end="false"
          :current-year="currentYear"
          :next-year="nextYear"
          @on-change="
            ({ type, value }) => onChange({ type, value, quarter: 4 })
          "
        />
      </li>
    </ul>
    <!-- {{ quarters }} -->
    <div v-if="!isDateSequential" class="alert alert-danger mt20">
      Dates must be sequential
    </div>
  </div>
</template>

<script>
import SelectDayMonthRange from "./select-day-month-range";

export default {
  name: "SelectDayMonthQuarter",

  components: {
    SelectDayMonthRange,
  },

  props: {
    value: {
      type: String,
      required: false,
      default: "1-1",
    },
    quarters: {
      type: Array,
      required: false,
      default: function () {
        return {
          start: "2020-1-1",
          end: "2020-3-30",
        };
      },
    },
    currentYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear();
      },
    },
    nextYear: {
      type: Number,
      required: false,
      default: () => {
        return new Date().getFullYear() + 1;
      },
    },
  },

  computed: {
    localQuarters: {
      get() {
        return this.quarters;
      },
      set(newValue) {
        this.$emit("quartes", newValue);
      },
    },
  },

  data: function () {
    return {
      key: 0,
      months: [],
      isDateSequential: true,
      quarter1: {
        start: "2020-1-1",
        end: "2020-3-31",
      },
      quarter2: {
        start: "2020-4-1",
        end: "2020-6-30",
      },
      quarter3: {
        start: "2020-7-1",
        end: "2020-9-30",
      },
      quarter4: {
        start: "2020-10-1",
        end: "2020-12-31",
        endNextYear: false,
      },
    };
  },

  mounted() {
    this.currentYear = new Date().getFullYear();
    this.nextYear = this.currentYear + 1;
    this.months = this.$refs.quarter1.$refs.startDate.months;
    this.setQuarters();
  },

  methods: {
    onChange({ type, value, quarter }) {
      let newDate;

      if (type === "start") {
        newDate = this.getDayBefore(value);
        let { dateDay } = this.extractDate(value);
        const changeQuarter =
          quarter > 1 ? `quarter${quarter - 1}` : "quarter4";

        this[changeQuarter].end = newDate;
      } else {
        if (quarter === 4) return;
        newDate = this.getDayAfter(value);
        this[`quarter${quarter + 1}`].start = newDate;
      }

      this.updateLocalQuarters({ type, value, quarter });
      this.setEndNextYear();
      this.validateQuartes();
      this.key++;
    },
    updateLocalQuarters({ type, value, quarter }) {
      this.localQuarters[0].start = this.quarter1.start;
      this.localQuarters[0].end = this.quarter1.end;

      this.localQuarters[1].start = this.quarter2.start;
      this.localQuarters[1].end = this.quarter2.end;

      this.localQuarters[2].start = this.quarter3.start;
      this.localQuarters[2].end = this.quarter3.end;

      this.localQuarters[3].start = this.quarter4.start;
      this.localQuarters[3].end = this.quarter4.end;
      this.localQuarters[3].endNextYear = this.quarter4.endNextYear;

      this.localQuarters[quarter - 1][type] = value;
    },
    setQuarters() {
      this.quarter1.start = this.localQuarters[0].start;
      this.quarter1.end = this.localQuarters[0].end;

      this.quarter2.start = this.localQuarters[1].start;
      this.quarter2.end = this.localQuarters[1].end;

      this.quarter3.start = this.localQuarters[2].start;
      this.quarter3.end = this.localQuarters[2].end;

      this.quarter4.start = this.localQuarters[3].start;
      this.quarter4.end = this.localQuarters[3].end;
    },
    setEndNextYear() {
      let lastDate = this.localQuarters[0].start;
      let isNextYear = false;
      let isBefore = false;
      this.localQuarters.forEach((quarter, i) => {
        if (i > 0) {
          isBefore = this.isBefore(lastDate, quarter.start);

          if (isBefore || isNextYear) {
            quarter.startNextYear = true;
            isNextYear = true;
          }
          lastDate = quarter.start;
        }

        isBefore = this.isBefore(lastDate, quarter.end);

        if (isBefore || isNextYear) {
          if (isBefore) {
            quarter.endNextYear = true;
            isNextYear = true;
          }
        }

        lastDate = quarter.start;
      });

      this.setQuarters();
      this.setLastDate();
    },
    setLastDate() {
      const firstDate = new Date(this.localQuarters[0].start);
      let closeYear = new Date(
        new Date(firstDate).setFullYear(firstDate.getFullYear() + 1)
      );
      closeYear = new Date(closeYear.setDate(closeYear.getDate() - 1));
      this.localQuarters[3].end = `${closeYear.getFullYear()}-${
        closeYear.getMonth() + 1
      }-${closeYear.getDate()}`;

      this.setQuarters();
      this.key++;
    },
    validateQuartes() {
      const q1_start = new Date(this.localQuarters[0].start);
      const q2_start = new Date(this.localQuarters[1].start);
      const q3_start = new Date(this.localQuarters[2].start);
      const q4_start = new Date(this.localQuarters[3].start);

      const q1_end = new Date(this.localQuarters[0].end);
      const q2_end = new Date(this.localQuarters[1].end);
      const q3_end = new Date(this.localQuarters[2].end);

      const q2_start_before_day = new Date(
        new Date(q2_start).setDate(q2_start.getDate() - 1)
      );
      const q3_start_before_day = new Date(
        new Date(q3_start).setDate(q3_start.getDate() - 1)
      );
      const q4_start_before_day = new Date(
        new Date(q4_start).setDate(q4_start.getDate() - 1)
      );

      if (
        q1_end > q1_start &&
        q2_end > q2_start &&
        q3_end > q3_start &&
        q1_end.toDateString() === q2_start_before_day.toDateString() &&
        q2_end.toDateString() == q3_start_before_day.toDateString() &&
        q3_end.toDateString() == q4_start_before_day.toDateString()
      ) {
        this.isDateSequential = true;
      } else {
        this.isDateSequential = false;
      }
    },
    getDayBefore(date) {
      date = new Date(date);
      const dateBefore = new Date(date.setDate(date.getDate() - 1));
      return `${dateBefore.getFullYear()}-${
        dateBefore.getMonth() + 1
      }-${dateBefore.getDate()}`;
    },
    getDayAfter(date) {
      date = new Date(date);
      const dateBefore = new Date(date.setDate(date.getDate() + 1));
      return `${dateBefore.getFullYear()}-${
        dateBefore.getMonth() + 1
      }-${dateBefore.getDate()}`;
    },
    extractDate(date) {
      date = date.split("-");
      return {
        dateYear: parseInt(date[0]),
        dateMonth: parseInt(date[1]),
        dateDay: parseInt(date[2]),
      };
    },
    isBefore(lastDate, date) {
      lastDate = lastDate.split("-");
      date = date.split("-");

      lastDate[1] = parseInt(lastDate[1]);
      lastDate[2] = parseInt(lastDate[2]);
      date[1] = parseInt(date[1]);
      date[2] = parseInt(date[2]);

      if (date[0] > lastDate[0]) {
        return false;
      } else if (date[0] < lastDate[0]) {
        return true;
      } else if (date[0] === date[0] && date[1] < lastDate[1]) {
        return true;
      } else if (date[0] === date[0] && date[1] > lastDate[1]) {
        return false;
      } else if (
        date[0] === lastDate[0] &&
        date[1] === lastDate[1] &&
        date[2] < lastDate[2]
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
.quarters-area {
  .quarters-list {
    display: flex;
    flex-wrap: wrap;
    flex-flow: 1;
    gap: 10px;

    li.quarters-list-item {
      flex-basis: 45%;
      flex-grow: 1;

      header {
        font-weight: bold;
      }

      .quarters-range {
        .select-day-month {
          .selected-area {
            margin: 0px 10px !important;
            min-width: 80px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
